import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import Header from "../header";
import Footer from "../footer";
import { leavecountdashboard, leavelist } from "../../service/dashboard";
import moment from "moment";

const LeaveDashboard = () => {
    const [lcount, setLCount] = useState("");
    const [pcount, setPCount] = useState("");
    const [leaveData, setLeaveData] = useState([]);
    const [fromdate, setFromDate] = useState("");
    const [todate, setToDate] = useState("");
    const navigate = useNavigate();
    useEffect(() => {

        const currentDate = new Date();
        const firstDay = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            1
        );
        listall(
            moment(firstDay).format("YYYY-MM-DD"),
            moment(new Date()).format("YYYY-MM-DD")
        );
    }, []);
    function listall(fdate, tdate) {
        setLeaveData([]);
        setFromDate(fdate);
        setToDate(tdate);
        const temp = new FormData();
        temp.append("from_date", fdate);
        temp.append("to_date", tdate);
        if (localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "5") {
            temp.append("user_id", localStorage.getItem("UID"));
        }
        leavelist(temp).then((res) => {
            if (res.status === true) {
                setLeaveData(res.data);
            }
        });

        const temp1 = new FormData();
        temp1.append("academy_id", localStorage.getItem("academy"));
        if (localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "5") {
            temp1.append("user_id", localStorage.getItem("UID"));
        }
        leavecountdashboard(temp1).then((res) => {
            if (res.status === true) {
                setLCount(res.data.leave_counts);
                setPCount(res.data.permission_counts);
            }
        });
    }
    const getStatusStyle = (status) => {
        if (status === "Approved") {
            return { color: "green", fontWeight: "bold" };
        } else if (status === "Rejected") {
            return { color: "red", fontWeight: "bold" };
        } else if (status === "Pending") {
            return { color: "blue", fontWeight: "bold" };
        } else {
            return { color: "brown", fontWeight: "bold" };
        }
    };
    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">

                        <Col xs={2} className="text-left align-self-end">
                            <h4 className="morehead-text">Leave</h4>
                        </Col>

                        <Col xs={10} className="text-right align-self-end">
                            <Link to={"/applyleave"} className="btn-outline-success green-btn btn-sm">
                                Apply Leave
                            </Link>
                            <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>

                    </Row>
                </div>
                <div className="row g-2 mt-1">
                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                        <div className="card fee-card">
                            <div className="card-header">
                                <h6 className="fw-bold text-center">Sick Leave</h6>
                            </div>
                            <div className="card-body text-center">
                                <div className="d-flex justify-content-around mt-2">
                                    <div>
                                        <h6 className="mb-1 text-success">Approved</h6>
                                        <h6 className="text-success">
                                            {lcount ? lcount.sick.approved : 0}
                                        </h6>
                                    </div>

                                    <div>
                                        <h6 className="mb-1 text-danger">Rejected</h6>
                                        <h6 className="text-danger">
                                            {lcount ? lcount.sick.rejected : 0}
                                        </h6>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                        <div className="card fee-card">
                            <div className="card-header">
                                <h6 className="fw-bold text-center">Casual Leave</h6>
                            </div>
                            <div className="card-body text-center">
                                <div className="d-flex justify-content-around mt-2">
                                    <div>
                                        <h6 className="mb-1 text-success">Approved</h6>
                                        <h6 className="text-success">
                                            {lcount ? lcount.casual.approved : 0}
                                        </h6>
                                    </div>

                                    <div>
                                        <h6 className="mb-1 text-danger">Rejected</h6>
                                        <h6 className="text-danger">
                                            {lcount ? lcount.casual.rejected : 0}
                                        </h6>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                        <div className="card fee-card">
                            <div className="card-header">
                                <h6 className="fw-bold text-center">Personal Leave</h6>
                            </div>
                            <div className="card-body text-center">
                                <div className="d-flex justify-content-around mt-2">
                                    <div>
                                        <h6 className="mb-1 text-success">Approved</h6>
                                        <h6 className="text-success">
                                            {lcount ? lcount.personal.approved : 0}
                                        </h6>
                                    </div>

                                    <div>
                                        <h6 className="mb-1 text-danger">Rejected</h6>
                                        <h6 className="text-danger">
                                            {lcount ? lcount.personal.rejected : 0}
                                        </h6>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                        <div className="card fee-card">
                            <div className="card-header">
                                <h6 className="fw-bold text-center">Permission</h6>
                            </div>
                            <div className="card-body text-center">
                                <div className="d-flex justify-content-around mt-2">
                                    <div>
                                        <h6 className="mb-1 text-success">Approved</h6>
                                        <h6 className="text-success">
                                            {pcount ? pcount.approved : 0}
                                        </h6>
                                    </div>

                                    <div>
                                        <h6 className="mb-1 text-danger">Rejected</h6>
                                        <h6 className="text-danger">
                                            {pcount ? pcount.rejected : 0}
                                        </h6>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="leave-container">
                    <div className="row">
                        <h4 className="subhead-text">Leave List</h4>

                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">

                                <label className="form-label fw-bold">From Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={fromdate}
                                    onChange={(e) => listall(e.target.value, todate)}
                                />
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">

                                <label className="form-label fw-bold">To Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={todate}
                                    onChange={(e) => listall(fromdate, e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    {leaveData.length > 0 ? (
                        leaveData.map((leave, index) => (
                            <div className="leave-card mt-2" key={index}>
                                <div><strong>Status:</strong> <span style={getStatusStyle(leave.status)}>
                                    {leave.status}
                                </span></div>
                                <div><strong>Username:</strong> {leave.username}</div>
                                <div><strong>Leave:</strong> {leave.leave_permission}</div>
                                <div><strong>Type:</strong> {leave.leave_type}</div>
                                <div><strong>Days:</strong> {leave.total_leave}</div>
                                <div><strong>From:</strong> {moment(leave.from_date).format("DD-MM-YYYY")}</div>
                                <div><strong>To:</strong> {moment(leave.to_date).format("DD-MM-YYYY")}</div>
                                <div><strong>Reason:</strong> {leave.reason}</div>
                            </div>
                        ))
                    ) : (
                        <div className="leave-card mt-2 text-center">
                            <div><strong>No Data Found</strong></div>
                        </div>
                    )}

                </div>
            </div>

            <Footer />
        </div>
    );
};

export default LeaveDashboard;
